import { useContext } from 'react';
import { EventManagerContext } from '../context/eventManagerContext';

export function useEventManager() {
  const context = useContext(EventManagerContext);

  if (!context) {
    throw new Error('useEventManager must be used inside EventManagerProvider');
  }

  return context;
}
